"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TakeOffPlane(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "take-off-plane",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M26.668 254.436L430.455 74.658c24.722-11.007 53.686.112 64.693 24.834 11.008 24.722-.11 53.687-24.833 64.694L66.528 343.963l-39.86-89.527z",
    fill: "#FFF"
  }), _react["default"].createElement("path", {
    d: "M63.514 361.945c-1.99 0-3.98-.42-5.834-1.26a14.14 14.14 0 01-7.672-8.724l-29.675-96.804c-2.087-6.809 1.224-14.108 7.723-17.025l393.29-176.494c32.375-14.526 70.538-.009 85.067 32.368 7.038 15.683 7.548 33.168 1.435 49.235-6.113 16.067-18.118 28.791-33.802 35.83l-73.748 33.096c-7.116 3.192-15.476.012-18.67-7.103-3.192-7.117-.012-15.476 7.103-18.669L462.48 153.3c18.167-8.153 26.313-29.563 18.16-47.729-8.153-18.166-29.565-26.312-47.728-18.16L50.995 258.8l21.331 69.585 216.75-97.269c7.116-3.193 15.475-.013 18.668 7.103 3.193 7.116.013 15.476-7.103 18.67L69.296 360.708a14.124 14.124 0 01-5.782 1.236",
    fill: "#1436B8"
  }), _react["default"].createElement("path", {
    fill: "#2CD5C4",
    d: "M62.512 189.475L14.17 211.17l47.917 137.609 94.065-42.213z"
  }), _react["default"].createElement("path", {
    d: "M31.817 218.776L70.38 329.53l63.282-28.399L58.3 206.892l-26.483 11.884zm30.269 144.17a14.165 14.165 0 01-13.378-9.508L.79 215.827c-2.417-6.94.874-14.575 7.579-17.583l48.343-21.694a14.167 14.167 0 0116.863 4.077l93.637 117.091a14.168 14.168 0 01-5.263 21.772l-94.065 42.213a14.154 14.154 0 01-5.8 1.241z",
    fill: "#1436B8"
  }), _react["default"].createElement("path", {
    fill: "#2CD5C4",
    d: "M130.057 85.06l-61.021 27.384 175.146 86.133 125.951-56.523z"
  }), _react["default"].createElement("path", {
    d: "M102.329 113.031l142.128 69.895 81.829-36.721-194.817-46.251-29.14 13.077zm141.853 99.713c-2.142 0-4.282-.486-6.251-1.453L62.784 125.156a14.17 14.17 0 01-7.914-12.962 14.174 14.174 0 018.366-12.674l61.022-27.384a14.156 14.156 0 019.072-.858l240.076 56.994a14.166 14.166 0 012.528 26.708l-125.953 56.522a14.156 14.156 0 01-5.799 1.242zM483.23 455.441H126.42c-7.824 0-14.166-6.342-14.166-14.166 0-7.824 6.342-14.166 14.166-14.166h356.81c7.824 0 14.166 6.342 14.166 14.166 0 7.824-6.342 14.166-14.166 14.166M60.268 455.441H28.75c-7.824 0-14.166-6.342-14.166-14.166 0-7.824 6.342-14.166 14.166-14.166h31.518c7.824 0 14.166 6.342 14.166 14.166 0 7.824-6.342 14.166-14.166 14.166",
    fill: "#1436B8"
  }))));
}

TakeOffPlane.defaultProps = {
  size: 30
};
var _default = TakeOffPlane;
exports["default"] = _default;